import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { map, startWith, debounceTime, delay, tap, filter, takeUntil } from 'rxjs/operators';
import { Roles } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
import { IContratistaModel } from 'src/app/models/interfaces/contratista/IContratistaModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { IFilterTipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/IFilterTipoVisitaModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-solicitud-master',
  templateUrl: './solicitud-master.component.html',
  styleUrls: ['./solicitud-master.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SolicitudMasterComponent implements OnInit {
  @Input() model: ISolicitudModel;
  @Input() disabled: boolean = false;
  @Input() escontratista: boolean = false;
  @Output() tipoVisitaEventChanged: EventEmitter<any> = new EventEmitter();

  listaSolicitantes: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaTipoVisita: TipoVisitaModel[] = new Array<TipoVisitaModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  idContratistaSelect: number = 0;
  myControl = new FormControl();
  filteredOptions!: Observable<ContratistaModel[]>;
  listaContratistas: ContratistaModel[] = new Array<ContratistaModel>();

  private _data = new BehaviorSubject<ISolicitudModel>(new SolicitudModel());

  // change data to use getter and setter
  @Input()
  set data(value: ISolicitudModel) {
    // set the latest value for _data BehaviorSubject
    this._data.next(value);
    if (value.idSolicitud != 0) {
      this.idContratistaSelect = value.idContratista ? value.idContratista : 0;
      this.cargarDatos();
    }
  };

  get data() {
    // get the latest value from _data BehaviorSubject
    return this._data.getValue();
  }

  /** list of banks */
  // protected banks: ContratistaModel[] = BANKS;

  /** control for the selected bank for server side filtering */
  public bankServerSideCtrl: FormControl = new FormControl();

  /** control for filter for server side. */
  public bankServerSideFilteringCtrl: FormControl = new FormControl();

  /** indicate search operation is in progress */
  public searching = false;

  /** list of banks filtered after simulating server side search */
  public filteredServerSideBanks: ReplaySubject<ContratistaModel[]> = new ReplaySubject<ContratistaModel[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  @ViewChild('singleSelect', { static: true }) singleSelect!: MatSelect;

  // form: FormGroup;
  notificarA = new FormControl('', [Validators.email]);
  idSede = new FormControl('0', [Validators.min(1)]);
  idTipoVisita = new FormControl('', [Validators.min(1)]);

  constructor(
    // private fb: FormBuilder,
    private sedeService: SedeService,
    private contratistaService: ContratistaService,
    private tipoVisitaService: TipoVisitaService,
    private usuarioService: SeguridadUsuarioService,
    private storage: StorageService,
  ) {

    this.model = new SolicitudModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompaniaSelected = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();
    if (!this.escontratista) {
      const filterTipoVisita: IFilterTipoVisitaModel = new FilterTipoVisitaModel();
      this.tipoVisitaService.getList(filterTipoVisita).subscribe((data: TipoVisitaModel[]) => {
        this.listaTipoVisita = data;
      });

      // this._data.subscribe(p => {
      //   this.listarContratistas();
      // });
    }

    let usuario = this.storage.getCurrentUser();
    this.model.idCompaniaSelected = usuario.companiaDefault.idCompania;
  }

  listarContratistas(): void {
    if (!this.escontratista) {
      this.listaContratistas = [];
      this.bankServerSideCtrl.setValue([]);
      if (this.model.idCompaniaSelected && this.model.idSedeSelected) {

        let contratistaFilter = new FilterContratistaModel();
        contratistaFilter.companias.push(this.model.idCompaniaSelected);
        contratistaFilter.idSede = this.model.idSedeSelected;
        this.contratistaService
          .getList(contratistaFilter)
          .subscribe((data: ContratistaModel[]) => {
            this.listaContratistas = data;
            console.log(this.model.idContratista);
            this.bankServerSideCtrl.setValue(this.model.idContratista);
            var lista = data.filter(p => p.idContratista === this.model.idContratista);
            if (this.idContratistaSelect != 0) {
              this.bankServerSideCtrl.setValue(this.idContratistaSelect);
              lista = data.filter(p => p.idContratista === this.idContratistaSelect);
            }
            this.filteredServerSideBanks.next(lista.slice());

          });

        // listen for search field value changes
        this.bankServerSideFilteringCtrl.valueChanges
          .pipe(
            filter(search => !!search),
            tap(() => this.searching = true),
            takeUntil(this._onDestroy),
            debounceTime(200),
            map(search => {
              if (!this.listaContratistas) {
                return [];
              }

              return this.listaContratistas.filter(bank => bank.nombre.toLowerCase().indexOf(search.toLowerCase()) > -1);
            }),
            delay(500),
            takeUntil(this._onDestroy)
          )
          .subscribe(filteredBanks => {
            this.searching = false;
            this.filteredServerSideBanks.next(filteredBanks);
          },
            error => {
              // no errors in our simulated example
              this.searching = false;
            });
      }
    }
  }

  sedeChanged(selectedValue: any) {

    this.listarContratistas();
    if (this.escontratista) {
      let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
      filterUsuario.idRol = Roles.SOLICITANTE;
      filterUsuario.idSede = this.model.idSedeSelected;

      this.usuarioService
        .getList(filterUsuario)
        .subscribe(
          (data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
            this.listaSolicitantes = data.items;
          }
        );
    }
  }

  companiaChanged() {
    this.listaSedes = [];
    this.model.idSedeSelected = undefined;
    const filterSede: IFilterSedeModel = new FilterSedeModel();
    if (this.model.idCompaniaSelected)
      filterSede.companias.push(this.model.idCompaniaSelected);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
        this.listarContratistas();
      });
  }

  tipoVisitaChanged(selectedValue: any) {
    // console.log(selectedValue);
    this.tipoVisitaEventChanged.emit(selectedValue.value);
  }

  cargarDatos() {
    this.listaSedes = [];
    const filterSede: IFilterSedeModel = new FilterSedeModel();
    if (this.model.idCompaniaSelected)
      filterSede.companias.push(this.model.idCompaniaSelected);
    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
        if (!this.escontratista)
          this.listarContratistas();
      });
  }

}
